// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Link } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

import {ReactComponent as LogoSVG} from "./../../assets/images/convert-logistics-logo.svg";
import { isShopifyApp } from 'context/UserAuthContext';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = ({url = process.env.REACT_APP_FRONTEND_URL, color = 'white', style = {}}) => {

    style = {
        minWidth: 'fit-content',
        display: 'flex',
        alignItems: 'center',
        fontWeight: 'bold',
        color: '#fff',
        fontSize: '1.1rem',
        ...style, 
        ':hover': {
            backgroundColor: '#98b2ca1f',
            cursor: 'pointer'
        }
    }

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Mantis" width="100" />
         *
         */
        <a href={url} style={style}>
            <LogoSVG width={32} height={32} style={{marginRight: 10}} />
            Convert Logistics
        </a>
    );
};

export default Logo;
